import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { DelimitedTextFormatReadSettings } from 'app/model/pipeline/copysource/format-read-settings/delimited-text-format-read-settings';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { formatReadSettingsAdapts, FormatReadSettingsAdapter } from './format-read-settings.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import {
    convertCompressionSettingsToResource,
    convertCompressionSettingsToModel
} from '../compression-read-settings/compression-read-settings.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DelimitedTextFormatReadSettings),
    asynchronous: true,
    adapts: {
        ...formatReadSettingsAdapts,
        skipLineCount: '*'
    }
})
export class DelimitedTextFormatReadSettingsAdapter extends FormatReadSettingsAdapter<
    DelimitedTextFormatReadSettings,
    Model.FormatReadSettings
> {
    protected override async _toResource(
        model: DelimitedTextFormatReadSettings
    ): Promise<Model.DelimitedTextFormatReadSettings> {
        const result: Model.DelimitedTextFormatReadSettings = FormatReadSettingsAdapter.getCommonReadSettingsProperties(
            Metamodel.modelFor(DelimitedTextFormatReadSettings).name
        );
        result.commentChar = ValueAdapter.toResource(model, DelimitedTextFormatReadSettings.COMMENT_CHAR);
        result.ignoreLeadingWhiteSpace = ValueAdapter.toResource(
            model,
            DelimitedTextFormatReadSettings.IGNORE_LEADING_WHITESPACE
        );
        result.ignoreTrailingWhiteSpace = ValueAdapter.toResource(
            model,
            DelimitedTextFormatReadSettings.IGNORE_TRAILING_WHITESPACE
        );
        result.addtionalNullValues = ValueAdapter.toResource(
            model,
            DelimitedTextFormatReadSettings.ADDTIONAL_NULL_VALUES
        );
        result.skipLineCount = ValueAdapter.toResource(model, DelimitedTextFormatReadSettings.SKIP_LINE_COUNT);

        await convertCompressionSettingsToResource(model.compressionProperties, result, this.context);

        return result;
    }

    protected override async _toModel(
        resource: Model.DelimitedTextFormatReadSettings,
        copySource: CopySource
    ): Promise<DelimitedTextFormatReadSettings> {
        const result = FormatReadSettingsAdapter.createReadSettingsWithCommonProperties(
            DelimitedTextFormatReadSettings.MODEL,
            copySource
        ) as DelimitedTextFormatReadSettings;
        ValueAdapter.toModel(result, DelimitedTextFormatReadSettings.COMMENT_CHAR, resource.commentChar);
        ValueAdapter.toModel(
            result,
            DelimitedTextFormatReadSettings.IGNORE_LEADING_WHITESPACE,
            resource.ignoreLeadingWhiteSpace
        );
        ValueAdapter.toModel(
            result,
            DelimitedTextFormatReadSettings.IGNORE_TRAILING_WHITESPACE,
            resource.ignoreTrailingWhiteSpace
        );
        ValueAdapter.toModel(
            result,
            DelimitedTextFormatReadSettings.ADDTIONAL_NULL_VALUES,
            resource.addtionalNullValues
        );
        ValueAdapter.toModel(result, DelimitedTextFormatReadSettings.SKIP_LINE_COUNT, resource.skipLineCount);

        await convertCompressionSettingsToModel(resource.compressionProperties, result, this.context);

        return result;
    }
}
